var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cotainer"},[_c('p',{staticClass:"logo-title"},[_vm._v("山西省职业教育铸魂育人计划项目监测与管理平台")]),_c('div',{staticClass:"center-wz"},[_c('div',{staticClass:"wz-item",on:{"click":function($event){return _vm.jumpPage({
              name: 'szStudio',
            })}}},[_vm._v("思政教育工作室")]),_c('div',{staticClass:"wz-item",on:{"click":function($event){return _vm.jumpPage({
              name: 'educationalBrand',
            })}}},[_vm._v("特色文化育人品牌")]),_c('div',{staticClass:"wz-item",on:{"click":function($event){return _vm.jumpPage({
              name: 'szMicroClass',
            })}}},[_vm._v("思政微课")])]),_c('p',{staticClass:"gdt"},[_vm._v("山西省教育厅")])])
}
var staticRenderFns = []

export { render, staticRenderFns }